module.exports = __webpack_public_path__ + "static/media/top-menu-active-icon.d06d5112.svg";